import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgHealth() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("mask", Object.assign({
      id: "Health_svg__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 24,
      height: 24
    }, {
      children: _jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      }, void 0)
    }), void 0), _jsxs("g", Object.assign({
      mask: "url(#Health_svg__a)"
    }, {
      children: [_jsx("path", {
        d: "M10.5 8v-.5a.5.5 0 00-.5.5h.5zm3 0h.5a.5.5 0 00-.5-.5V8zm-3 2.5v.5a.5.5 0 00.5-.5h-.5zm-2.5 0V10a.5.5 0 00-.5.5H8zm0 3h-.5a.5.5 0 00.5.5v-.5zm2.5 0h.5a.5.5 0 00-.5-.5v.5zm0 2.5H10a.5.5 0 00.5.5V16zm3 0v.5a.5.5 0 00.5-.5h-.5zm0-2.5V13a.5.5 0 00-.5.5h.5zm2.5 0v.5a.5.5 0 00.5-.5H16zm0-3h.5a.5.5 0 00-.5-.5v.5zm-2.5 0H13a.5.5 0 00.5.5v-.5zm-3-2h3v-1h-3v1zm.5 2V8h-1v2.5h1zM8 11h2.5v-1H8v1zm.5 2.5v-3h-1v3h1zm2-.5H8v1h2.5v-1zm.5 3v-2.5h-1V16h1zm2.5-.5h-3v1h3v-1zm-.5-2V16h1v-2.5h-1zm3-.5h-2.5v1H16v-1zm-.5-2.5v3h1v-3h-1zm-2 .5H16v-1h-2.5v1zM13 8v2.5h1V8h-1z",
        fill: "currentColor"
      }, void 0), _jsx("rect", {
        x: 1,
        y: 12,
        width: 15.5,
        height: 15.5,
        rx: 3,
        transform: "rotate(-45 1 12)",
        stroke: "currentColor",
        strokeLinejoin: "round"
      }, void 0)]
    }), void 0)]
  }), void 0);
}

export default SvgHealth;